
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function PlayerBlacklistsPage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-900 to-black text-white">
      {/* Header */}
      <header className="relative z-50">
        <div className="container mx-auto px-4 py-6">
          <div className="flex items-center justify-between">
            {/* Logo and Brand */}
            <Link to="/" className="flex items-center space-x-3">
              <div className="w-14 h-14 flex items-center justify-center">
                <img 
                  src="https://static.readdy.ai/image/dcd65f13a790094d0aa5adf5c5f61db5/d92e14626dcee2662ced5b45bc6a77f4.png"
                  alt="Tactical Arms Logo"
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <h1 className="text-xl font-bold text-white">Tactical Arms</h1>
                <p className="text-sm text-gray-300">NXT Cam Properties • Firearms • Ammunition • Tactical Gear</p>
              </div>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-8">
              <Link to="/" className="text-gray-300 hover:text-white transition-colors">
                Home
              </Link>
              <Link to="/official-discounts" className="text-gray-300 hover:text-white transition-colors">
                Official Discounts
              </Link>
              <Link to="/shop" className="text-gray-300 hover:text-white transition-colors">
                Shop
              </Link>
              <Link to="/employee-application" className="text-gray-300 hover:text-white transition-colors">
                Employee Application
              </Link>
              <Link to="/employment-list" className="text-gray-300 hover:text-white transition-colors">
                Employment List
              </Link>
              <div className="relative group">
                <button className="text-yellow-400 font-medium border-b-2 border-yellow-400 pb-1 flex items-center space-x-1">
                  <span>Blacklists</span>
                  <i className="ri-arrow-down-s-line"></i>
                </button>
                <div className="absolute top-full left-0 mt-2 w-64 bg-gray-800 rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                  <div className="py-2">
                    <Link to="/blacklists/player-blacklists" className="block px-4 py-2 text-yellow-400 bg-gray-700 font-medium">
                      Player Blacklists
                    </Link>
                    <Link to="/blacklists/business-mafia-blacklists" className="block px-4 py-2 text-gray-300 hover:text-white hover:bg-gray-700 transition-colors">
                      Business/Mafia Blacklists
                    </Link>
                  </div>
                </div>
              </div>
            </nav>

            {/* Mobile Menu Button */}
            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="lg:hidden w-10 h-10 flex items-center justify-center text-white hover:text-yellow-400 transition-colors"
            >
              <i className={`text-xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <div className="lg:hidden mt-4 bg-gray-800 rounded-lg p-4">
              <nav className="flex flex-col space-y-3">
                <Link to="/" className="text-gray-300 hover:text-white transition-colors py-2">
                  Home
                </Link>
                <Link to="/official-discounts" className="text-gray-300 hover:text-white transition-colors py-2">
                  Official Discounts
                </Link>
                <Link to="/shop" className="text-gray-300 hover:text-white transition-colors py-2">
                  Shop
                </Link>
                <Link to="/employee-application" className="text-gray-300 hover:text-white transition-colors py-2">
                  Employee Application
                </Link>
                <Link to="/employment-list" className="text-gray-300 hover:text-white transition-colors py-2">
                  Employment List
                </Link>
                <div className="border-t border-gray-700 pt-3 mt-3">
                  <p className="text-gray-400 text-sm mb-2">Blacklists</p>
                  <Link to="/blacklists/player-blacklists" className="text-yellow-400 font-medium py-2 pl-4 block">
                    Player Blacklists
                  </Link>
                  <Link to="/blacklists/business-mafia-blacklists" className="text-gray-300 hover:text-white transition-colors py-2 pl-4 block">
                    Business/Mafia Blacklists
                  </Link>
                </div>
              </nav>
            </div>
          )}
        </div>
      </header>

      {/* Page Header */}
      <section className="py-16 bg-gray-900/50">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h2 className="text-4xl font-bold text-yellow-400 mb-4">Player Blacklists</h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Official blacklist documentation for players banned from Tactical Arms services and facilities. This list is maintained for security and compliance purposes.
            </p>
          </div>
        </div>
      </section>

      {/* Blacklist Document */}
      <section className="py-12">
        <div className="container mx-auto px-4">
          <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-8">
            <div className="mb-6">
              <h3 className="text-2xl font-bold text-white mb-4">Official Player Blacklist Document</h3>
              <p className="text-gray-300 mb-6">
                The following document contains the complete list of players who have been banned from Tactical Arms facilities and services. This information is maintained for security purposes and regulatory compliance.
              </p>
            </div>

            {/* Embedded Google Document */}
            <div className="bg-white rounded-lg overflow-hidden">
              <iframe
                src="https://docs.google.com/document/d/1PRUpWDCmMbVR4ykWYT_16SAeMjV6SM-gpk1FPACPQB0/edit?usp=sharing"
                width="100%"
                height="800"
                className="border-0"
                title="Player Blacklists Document"
              ></iframe>
            </div>

            {/* Document Info */}
            <div className="mt-6 p-4 bg-yellow-500/10 border border-yellow-500/20 rounded-lg">
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-information-line text-yellow-400"></i>
                </div>
                <div>
                  <h4 className="text-yellow-400 font-bold mb-2">Important Notice</h4>
                  <p className="text-gray-300 text-sm leading-relaxed">
                    This blacklist is maintained in accordance with federal and state regulations. All entries are documented with proper justification and review processes. For questions regarding blacklist status or appeals, please contact our compliance department.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Related Links */}
      <section className="py-16 bg-black/30">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-white mb-4">Related Information</h3>
            <p className="text-xl text-gray-300">
              Additional blacklist resources and compliance documentation
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-8 text-center">
              <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-building-line text-2xl text-black"></i>
              </div>
              <h4 className="text-xl font-bold text-white mb-3">Business/Mafia Blacklists</h4>
              <p className="text-gray-300 mb-6">
                View blacklisted businesses and organizations prohibited from Tactical Arms services.
              </p>
              <Link 
                to="/blacklists/business-mafia-blacklists" 
                className="bg-yellow-500 hover:bg-yellow-600 text-black font-bold py-3 px-6 rounded-lg transition-colors whitespace-nowrap cursor-pointer inline-block"
              >
                View Business Blacklists
              </Link>
            </div>

            <div className="bg-gray-800/50 backdrop-blur-sm rounded-xl p-8 text-center">
              <div className="w-16 h-16 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-2xl text-black"></i>
              </div>
              <h4 className="text-xl font-bold text-white mb-3">Compliance Information</h4>
              <p className="text-gray-300 mb-6">
                Learn about our security protocols and compliance procedures for blacklist management.
              </p>
              <Link 
                to="/employee-application" 
                className="border-2 border-yellow-400 text-yellow-400 hover:bg-yellow-400 hover:text-black font-bold py-3 px-6 rounded-lg transition-colors whitespace-nowrap cursor-pointer inline-block"
              >
                Contact Compliance
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black py-12">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center">
                  <img 
                    src="https://static.readdy.ai/image/dcd65f13a790094d0aa5adf5c5f61db5/d92e14626dcee2662ced5b45bc6a77f4.png"
                    alt="Tactical Arms Logo"
                    className="w-full h-full object-contain"
                  />
                </div>
                <span className="text-xl font-bold text-white">Tactical Arms</span>
              </div>
              <p className="text-gray-400 leading-relaxed">
                Your trusted source for premium firearms, ammunition, and tactical equipment. A division of NXT Cam Properties.
              </p>
            </div>

            <div>
              <h4 className="text-white font-bold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li><Link to="/shop" className="text-gray-400 hover:text-yellow-400 transition-colors">Shop</Link></li>
                <li><Link to="/official-discounts" className="text-gray-400 hover:text-yellow-400 transition-colors">Discounts</Link></li>
                <li><Link to="/employee-application" className="text-gray-400 hover:text-yellow-400 transition-colors">Careers</Link></li>
                <li><Link to="/employment-list" className="text-gray-400 hover:text-yellow-400 transition-colors">Employment</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-bold mb-4">Blacklists</h4>
              <ul className="space-y-2">
                <li><Link to="/blacklists/player-blacklists" className="text-gray-400 hover:text-yellow-400 transition-colors">Player Blacklists</Link></li>
                <li><Link to="/blacklists/business-mafia-blacklists" className="text-gray-400 hover:text-yellow-400 transition-colors">Business/Mafia Blacklists</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-bold mb-4">Contact Info</h4>
              <div className="space-y-2 text-gray-400">
                <p>Licensed Firearms Dealer</p>
                <p>Professional Grade Equipment</p>
                <p>NXT Cam Properties</p>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Tactical Arms - NXT Cam Properties. All rights reserved.
            </p>
            <div className="flex items-center space-x-4 mt-4 md:mt-0">
              <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-yellow-400 transition-colors text-sm">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}